import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6c8d298"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","height":"100%"} }
const _hoisted_2 = { style: {"position":"relative","margin-left":"auto","margin-right":"auto","height":"100%","display":"flex"} }
const _hoisted_3 = {
  class: "v-login_left",
  style: {"position":"relative","padding":"30px","flex":"1 1 0%"}
}
const _hoisted_4 = { style: {"height":"calc(100% - 60px)","justify-content":"center","align-items":"center","display":"flex"} }
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = { style: {"color":"rgba(255, 255, 255, 0.8)","font-size":"1.875rem","line-height":"2.25rem"} }
const _hoisted_7 = { style: {"position":"relative","padding":"30px","flex":"1 1 0%","background":"#fff"} }
const _hoisted_8 = { style: {"text-align":"right"} }
const _hoisted_9 = { style: {"max-width":"500px","width":"100%","margin":"auto","height":"100%","align-items":"center","display":"flex"} }
const _hoisted_10 = { class: "vo-login-title" }
const _hoisted_11 = { style: {"width":"100%","padding-top":"15px"} }
const _hoisted_12 = { style: {"width":"100%","padding-top":"15px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mgt-20 fs-10 fc-dis" }, [
  /*#__PURE__*/_createElementVNode("span", null, "* 温馨提示：建议使用谷歌、Microsoft Edge，版本 79.0.1072.62 及以上浏览器，360浏览器请使用极速模式")
], -1))

import { ref, reactive, unref, onMounted, onBeforeMount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ElImage, ElForm, FormRules, ElMessage, ElMessageBox } from 'element-plus';
import { LocalesSelect } from '@/components/LocalesSelect/Index';
import { useAppStore } from '@/store/app';
import { useLocales } from '../../hooks/useLocales';
import { Session } from '../../utils/storage';
import { GetSysCompanyApi } from '@/apis/companys/company.api';
import { AccountLoginApi } from '../../apis/accounts/accounts.api';
import { CompanySelectDto } from '@/apis/companys/company.type';
import { LoginModel } from '@/apis/accounts/accounts.type';
import { ModuleTree } from '../../apis/modules/modules.type';
import { initTrendsRoutes } from '@/utils/trends.unils';
import { useDictionary } from '@/store/dictionary.store';
import UserRegisterDialog from './components/userRegisterDialog.vue';




export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();
const { push, replace } = useRouter();
const { query } = useRoute();
const appStore = useAppStore();
const writerRef = ref<ComponentRef<typeof UserRegisterDialog>>();

const boxLoginBg = require('@/assets/svgs/login-box-bg.svg');

const isLoading = ref<boolean>(false);
const companyList = ref<CompanySelectDto[]>();
const elFormRef = ref<ComponentRef<typeof ElForm>>();
const loginSchema = reactive<LoginModel>({ username: '', user_id:'', password: '', company_id: 'WYSY' });

/* 验证规则 */
const formRules = reactive<FormRules>({
	company_id: [{ required: true, message:  t('login2.noNullCompany'), trigger: 'blur' }],
	username: [{ required: true, message: t('login2.noNullAccount'), trigger: 'blur' }],
	password: [{ required: true, message: t('login2.noNullPassword'), trigger: 'blur' }],
});

/* 读取所属公司选择列表 */
const getCompanyList = () => {
	isLoading.value = true;

	GetSysCompanyApi()
		.then((res) => {
			if (!res.succeeded) {
				ElMessage.error(`获取所属公司列表失败，可能原因：${res.errors}。`);
			} else {
				const list = res.data || [];

				companyList.value = list;

				const defCompany = list.filter((item: CompanySelectDto) => {
					return item.id == 'WYSY';
				});

				if (defCompany && defCompany.length > 0) {
					unref(loginSchema).company_id = defCompany[0].id;
				}
			}
		})
		.finally(() => {
			isLoading.value = false;
		});
};

/* 生成路由数据 */
const getRouter = (data: ModuleTree[]): AppCustomRouteRecordRaw[] => {
	const routerItems = data.map((node: ModuleTree) => {
		let routerItem: AppCustomRouteRecordRaw = {
			path: node.path,
			name: node.code,
			component: node.component_path,
			meta: JSON.parse(node.meta),
			children: (node.child?.length || 0) > 0 ? getRouter(node.child!) : [],
		};
		return routerItem;
	});

	return routerItems;
};

/* WEb登录 */
const onLoginBtnClick = () => {
	unref(elFormRef)?.validate(async (valide: boolean) => {
		if (!valide) return;

		isLoading.value = true;
		
		loginSchema.user_id = loginSchema.username

		const { succeeded, errors, data } = await AccountLoginApi(loginSchema);
		if (!succeeded) {
			ElMessage.error(`登录失败！${errors}`);
		} else {
			Session.set('token', data.token); // 缓存token
			appStore.setLoginInfo(data); // 设置登录信息

			await initTrendsRoutes(); // 初始化系统缓存，路由信息

			push('/home');
			ElMessage.success('登录成功');
		}

		isLoading.value = false;
	});
};

/*用户注册*/
const onRegisterBtnClick = () => {
	isLoading.value = false;
	useDictionary().setDictionaryMap();
	// unref(writerRef)?.openDialog();
	unref(writerRef)?.create();
};

/* 页面点开前 */
onBeforeMount(() => {
	// Demo：userNo=R26353&action=ContractAudit&flowNo=199&nodeId=19902&workId=1923202&fId=0

	const action = query.action as string;
	const userId = query.userNo as string;
	const oaWorkId = query.workId as string;

	if (action) {
		const schema = { user_id: userId, password: 'G273kL#Dhr5GcfnG', company_id: 'WYSY' };

		AccountLoginApi(schema).then((res) => {
			if (!res.succeeded) {
				ElMessageBox({ type: 'warning', title: t('notify.success'), message: `${res.errors}`, lockScroll: false }).then(() => {
					replace({ path: '/login' });
				});
			} else {
				ElMessage.success(t('notify.fail'));
				appStore.setLoginInfo(res.data);
				replace({ path: '/contract/auditbyerp', query: { workId: oaWorkId } });
			}
		});
	}
});

onMounted(() => {
	getCompanyList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ElImage), { src: _unref(boxLoginBg) }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('title.welcome', '欢迎使用旺盈合同管理系统')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(LocalesSelect))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_card, {
              style: {"width":"100%","padding":"20px 30px"},
              shadow: "never"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(t)('buttons.login', '登录')), 1),
                _createVNode(_unref(ElForm), {
                  ref_key: "elFormRef",
                  ref: elFormRef,
                  disabled: isLoading.value,
                  model: _unref(loginSchema),
                  rules: _unref(formRules),
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('login.company', '所属公司'),
                      prop: "company_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(loginSchema).company_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(loginSchema).company_id) = $event)),
                          placeholder: "请选择所属公司",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.short_name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('login.username','用户名'),
                      prop: "username"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          modelValue: _unref(loginSchema).username,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(loginSchema).username) = $event)),
                          placeholder: "请输入登录账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('login.password','密码'),
                      prop: "password"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "password",
                          modelValue: _unref(loginSchema).password,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(loginSchema).password) = $event)),
                          placeholder: _unref(t)('placeholder.emptypasswore'),
                          "show-password": ""
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["disabled", "model", "rules"]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    loading: isLoading.value,
                    round: "",
                    style: {"width":"100%","background-color":"#fa4d09","border-color":"#fa4d09"},
                    onClick: onLoginBtnClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('buttons.login', '登录')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    loading: isLoading.value,
                    round: "",
                    style: {"width":"100%","background-color":"#fa4d09","border-color":"#fa4d09"},
                    onClick: onRegisterBtnClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('buttons.register', '注册')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(UserRegisterDialog, {
      ref_key: "writerRef",
      ref: writerRef
    }, null, 512)
  ], 64))
}
}

})